import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Standard responsive breakpoints for the application:
 * - Mobile: < 960px (below 'md')
 * - Desktop: >= 960px ('md' and above)
 * - Small screens: < 600px (below 'sm')
 * - Large screens: >= 1280px ('lg' and above)
 */

/**
 * Hook to determine if the current screen size is mobile (< 960px).
 * Use this as the standard for mobile/desktop distinction.
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

/**
 * Hook to determine if the current screen size is desktop (>= 960px).
 * Use this as the standard for mobile/desktop distinction.
 */
export const useIsDesktop = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
};

/**
 * Hook to determine if the current screen size is small (< 600px).
 * Use this for phone-specific layouts.
 */
export const useIsSmallScreen = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};

/**
 * Hook to determine if the current screen size is large (>= 1280px).
 * Use this for large desktop-specific layouts.
 */
export const useIsLargeScreen = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('lg'));
};
